import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, withCtx as _withCtx } from "vue"

const _hoisted_1 = { key: 1 }
const _hoisted_2 = { class: "element-box" }
const _hoisted_3 = { class: "row align-items-center justify-content-between" }
const _hoisted_4 = { class: "mt-3" }
const _hoisted_5 = { class: "table-responsive overflow-auto pt-4 mb-3" }
const _hoisted_6 = { class: "table table-striped" }
const _hoisted_7 = { class: "text-end" }
const _hoisted_8 = { class: "text-end" }
const _hoisted_9 = { class: "text-end" }
const _hoisted_10 = { class: "text-end" }
const _hoisted_11 = { class: "text-end" }

import analyticsService from '@/api/Analytics';
import Loader from '@/components/Loader.vue';
import PageTemplate from '@/components/PageTemplate.vue';
import Pagination from '@/components/Pagination.vue';
import PerPage from '@/components/PerPage.vue';
import {CloseToast, ErrorToast} from '@/components/VueToast';
// @ts-ignore
import {getOfficeDropdown} from '@/shared/dropdowns';
import {downloadFile} from '@/shared/functions';
import Search from '@/views/App/Analytics/TerminatedCoaching/PrivateCoaching/Search.vue';
import {onMounted, ref} from 'vue';
import ExcelExportButton from "@/components/ExcelExportButton.vue";
import BackButton from "@/components/button/BackButton.vue";

// ---------- Types ----------

interface ITerminatedCoachingStats {
  totalCount: number;
  endedCount: number;
  terminatedCount: number;
  terminatedPctOfAll: number;
  terminatedPctOfEnded: number;
}

interface ITerminatedCoachingOffice {
  officeId: number;
  officeName: string;
  terminatedCoachingData: ITerminatedCoachingStats;
}

interface IPagination {
  total_pages: number;
  current_page: number;
  items_per_page?: number;
  total_items?: number;
}

interface ICoachingList {
  data: ITerminatedCoachingOffice[];
  pagination: IPagination;
}

interface IFilters {
  officeIds: number[];
  startDate: string;
  endDate: string;
}

// ---------- State ----------


export default /*@__PURE__*/_defineComponent({
  __name: 'List',
  setup(__props) {

const currentYear = new Date().getFullYear();

const filters = ref<IFilters>({
  officeIds: [],
  startDate: `01.01.${currentYear}`,
  endDate: `31.12.${currentYear}`,
});

const coachingList = ref<ICoachingList>();
const officeDropdown = ref([]);
const isSearching = ref(false);
const isLoaded = ref(false);
const isExcelLoaded = ref(false);

async function getExcelExport() {
  await downloadFile('/analytics/terminated/private-coaching/excel-export',
      undefined,
      {
        ...filters.value,
        'officeIds[]': filters.value.officeIds,
      },
      false,
      'GET',
      isExcelLoaded
  )
}

async function getCoachingList(
    page = 1,
    perPage?: number,
    passedFilters?: IFilters
) {
  CloseToast();

  if (passedFilters) {
    isSearching.value = true;
  }
  const perPageRes = coachingList.value?.pagination?.items_per_page;

  try {
    const {data} = await analyticsService.getTerminatedPrivateCoachingList({
      ...(passedFilters ? passedFilters : filters.value),
      page: page,
      limit: perPage ?? perPageRes,
    });

    coachingList.value = data.data;
    isSearching.value = false;
  } catch (error) {
    await ErrorToast(error);
    isSearching.value = false;
  }
}

onMounted(async () => {
  await Promise.all([
    getOfficeDropdown(officeDropdown),
    getCoachingList()
  ]);

  isLoaded.value = true;
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(PageTemplate, null, {
    default: _withCtx(() => [
      (!isLoaded.value)
        ? (_openBlock(), _createBlock(Loader, { key: 0 }))
        : (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createVNode(BackButton, {
              label: _ctx.$t('general.button.back'),
              to: { name: 'analyticsHome' },
              marginBottom: "5"
            }, null, 8, ["label"]),
            _cache[2] || (_cache[2] = _createElementVNode("div", { class: "d-flex justify-content-between" }, [
              _createElementVNode("h6", { class: "element-header" }, " Davon vorzeitig beendet ")
            ], -1)),
            _createElementVNode("div", _hoisted_2, [
              _cache[1] || (_cache[1] = _createElementVNode("h5", { class: "form-header mb-4" }, "Einzelcoaching", -1)),
              _createVNode(Search, {
                filters: filters.value,
                loading: isSearching.value,
                officeDropdown: officeDropdown.value,
                onSearch: getCoachingList
              }, null, 8, ["filters", "loading", "officeDropdown"]),
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("div", _hoisted_4, [
                  _createVNode(PerPage, {
                    values: [10, 25, 50, 100],
                    "onUpdate:perPage": getCoachingList
                  }),
                  _createVNode(ExcelExportButton, {
                    style: {"margin-right":"15px"},
                    label: _ctx.$t('general.excel_export'),
                    loading: isExcelLoaded.value,
                    onClick: getExcelExport
                  }, null, 8, ["label", "loading"])
                ])
              ]),
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("table", _hoisted_6, [
                  _cache[0] || (_cache[0] = _createElementVNode("thead", null, [
                    _createElementVNode("tr", null, [
                      _createElementVNode("th", null, "Standort"),
                      _createElementVNode("th", { class: "text-end" }, "Gesamt"),
                      _createElementVNode("th", { class: "text-end" }, "Beendet"),
                      _createElementVNode("th", { class: "text-end" }, "Abgebrochen"),
                      _createElementVNode("th", { class: "text-end" }, "Abbruchquote (% von Gesamt)"),
                      _createElementVNode("th", { class: "text-end" }, "Abbruchquote (% von Beendet)")
                    ])
                  ], -1)),
                  _createElementVNode("tbody", null, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(coachingList.value?.data, (office) => {
                      return (_openBlock(), _createElementBlock("tr", {
                        key: office.officeId
                      }, [
                        _createElementVNode("td", null, _toDisplayString(office.officeName), 1),
                        _createElementVNode("td", _hoisted_7, _toDisplayString(office.terminatedCoachingData.totalCount), 1),
                        _createElementVNode("td", _hoisted_8, _toDisplayString(office.terminatedCoachingData.endedCount), 1),
                        _createElementVNode("td", _hoisted_9, _toDisplayString(office.terminatedCoachingData.terminatedCount), 1),
                        _createElementVNode("td", _hoisted_10, _toDisplayString(office.terminatedCoachingData.terminatedPctOfAll) + " %", 1),
                        _createElementVNode("td", _hoisted_11, _toDisplayString(office.terminatedCoachingData.terminatedPctOfEnded) + " %", 1)
                      ]))
                    }), 128))
                  ])
                ])
              ]),
              ((coachingList.value?.pagination?.total_pages ?? 0) > 1)
                ? (_openBlock(), _createBlock(Pagination, {
                    key: 0,
                    totalPages: coachingList.value?.pagination?.total_pages,
                    currentPage: coachingList.value?.pagination?.current_page,
                    totalItems: coachingList.value?.pagination?.total_items,
                    perPage: coachingList.value?.pagination?.items_per_page,
                    onPagechanged: getCoachingList
                  }, null, 8, ["totalPages", "currentPage", "totalItems", "perPage"]))
                : _createCommentVNode("", true)
            ])
          ]))
    ]),
    _: 1
  }))
}
}

})